import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=549a0103&"
import script from "./Deductions.vue?vue&type=script&lang=js&"
export * from "./Deductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports